function ArrowLeft(){
    return (
       <svg className="w1" viewBox="0 0 32 32" >
           <path stroke="none" fill="#591F56" d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path>
       </svg>
    )
   }

export default ArrowLeft;